export const Constants = {
  CONTACTS: [
    { id: 1, description: 'Primary' },
    { id: 2, description: 'Secondary' },
    { id: 3, description: 'Other' },
  ],
  DELIVERY_MOTHODS: [
    { id: 1, description: 'Postal Mail' },
    { id: 2, description: 'Electronic Mail' },
    { id: 3, description: 'Parent Portal' },
  ],
  uploadFileTypeAllowed: [
    '.jpg',
    '.jpeg',
    '.png',
    '.tif',
    '.tiff',
    '.pdf',
    '.txt',
    '.xls',
    '.xlsx',
    '.doc',
    '.docx',
    '.pptx',
    '.svg',
    '.pptx',
  ],
  maxFileuploadSize: 30000000, //Unit is in bytes which is 30MB
  minFileuploadSize: 300, //Unit is in bytes which is 1KB
  PROVIDER_SERVICES: [
    { id: 'Special Class' },
    { id: 'SCIS' },
    { id: 'SEIT' },
    { id: 'Related Service' },
    { id: 'Related Service Only' },
  ],
  IEP_MEETINGTYPE: [
    {
      id: 1,
      description: 'Initial',
    },
    { id: 5, description: 'Annual Review' },

    {
      id: 2,
      description: 'Reevaluation',
    },
    {
      id: 3,
      description: 'Additional Reevaluation',
    },
  ],
  EIOutreachToFromDropdown: [
    {
      id: 1,
      description: 'Parent/Guardian/Foster Parent',
      sortOrder: 1,
      value: 'Par/Guar/Fost Parent',
      indicator: null,
      extDescr: null,
    },
    {
      id: 2,
      description: 'CPSE - CC, Admin, Chairperson',
      sortOrder: 2,
      value: 'CPSE-CC,Admin,Chairp',
      indicator: null,
      extDescr: null,
    },
    {
      id: 3,
      description: 'EI Transition Team - TC, ™',
      sortOrder: 3,
      value: 'EI Transition Team',
      indicator: null,
      extDescr: null,
    },
    {
      id: 4,
      description: 'Foster Care Planner/Agency',
      sortOrder: 4,
      value: 'Foster Planner/Agenc',
      indicator: null,
      extDescr: null,
    },
    {
      id: 5,
      description: 'EISC/EI Regional Office',
      sortOrder: 5,
      value: 'EISC/EI Reg Off',
      indicator: null,
      extDescr: null,
    },
    {
      id: 6,
      description: 'MDE',
      sortOrder: 6,
      value: 'MDE',
      indicator: null,
      extDescr: null,
    },
    {
      id: 7,
      description: 'Preschool Program',
      sortOrder: 7,
      value: 'Preschool Program',
      indicator: null,
      extDescr: null,
    },
    {
      id: 8,
      description: 'Other',
      sortOrder: 8,
      value: 'Other',
      indicator: null,
      extDescr: null,
    },
  ],

  languageChangeRestrictedAssessments: [
    {
      id: 29,
      description: 'Psychiatric Assessment',
    },
    {
      id: 31,
      description: 'Psychoeducational Assessment',
    },
    {
      id: 32,
      description: 'Psychological Assessment',
    },
    {
      id: 33,
      description: 'Psychological Update',
    },
    {
      id: 36,
      description: 'Speech and Language Assessment',
    },
  ],
  releaseNotes: {
    DOE_EXTERNAL:
      'https://drive.google.com/drive/u/1/folders/1txkPm1csCU3VR8F1tfi1i5ka2bf4q_8A',
    NON_DOE_EXTERNAL:
      'https://nycdoe.sharepoint.com/sites/SEO-SEDMSReview/SitePages/CollabHome.aspx',
  },
  kipRoleIds: [
    56, 57, 43, 47, 41, 54, 45, 51, 50, 55, 49, 4, 40, 42, 44, 48, 52, 46, 53,
  ],
  kipExcludedRoleIds: [36, 37, 1, 35],
  review: 'review',
  NOTIFICATION_ERROR_MESSAGE:
    'Fetching notifications failed. Please try again later.',
};
export interface IepConstants {
  relatedServices: string;
  assistiveTechnology: string;
  seitDescription: string;
}

export const iepConstants: IepConstants = {
  relatedServices: 'Related Services',
  assistiveTechnology: 'Assistive Technology',
  seitDescription: 'Special Education Itinerant Teacher Services (SEIT)',
};

export interface ContactDescription {
  primary: string;
  secondary: string;
}

export const contactDescriptions: ContactDescription = {
  primary: 'Primary',
  secondary: 'Secondary',
};

export interface GridRoutes {
  eiTransition: string;
  eventLog: string;
}

export interface DashboardLabels {
  upcomingKpi: string;
}

export const gridRoutes: GridRoutes = {
  eiTransition: 'eitransition',
  eventLog: 'EventLog',
};

export const dashboardLabels: DashboardLabels = {
  upcomingKpi: 'Upcoming KPI',
};

export const FILESIZEMESSAGE: string =
  'File Size accepted is between 1 KB to 28 MB';
